const takeActions = {
    pageName: 'Take Actions',
    inputs: [
        
    ]
};

export default takeActions;